<template>
  <div>
    <div>
      <div class="flex flex-col">
        <div class="-my-2 -mx-4 overflow-x-auto sm:-mx-6 lg:-mx-8">
          <div class="inline-block min-w-full py-2 align-middle md:px-6 lg:px-8">
            <div class="overflow-hidden shadow ring-1 ring-black ring-opacity-5 md:rounded-lg">
              <Table :columns="columns" :data="sellers" :isDeletable="hasAccessToAdminDashboard" @delete="deleteSeller">
                <template #complete="{ row }">
                  <GenericButton v-if="sellerIncomplete(row)" @click="selectedSeller = row">
                    <span class="text-xs">{{ $t("Complete") }}</span>
                  </GenericButton>
                  <div v-else>
                    <CheckIcon class="h-5 w-5 text-green-500" aria-hidden="true" />
                  </div>
                </template>
              </Table>
            </div>
          </div>
        </div>
      </div>
    </div>
    <SellerUpdate
      :isOpen="isPresent(selectedSeller)"
      :selectedSeller="selectedSeller"
      @closeSellerUpdate="selectedSeller = null"
      @getSellers="$emit('getSellers')"
    />
  </div>
</template>

<script>
import { Table, GenericButton } from "@estaly/ui";
import SellerUpdate from "@/views/pos/seller/SellerUpdate.vue";
import { isPresent } from "@/utils/validation";
import { CheckIcon } from "@heroicons/vue/solid";
import { mapActions, mapGetters } from "vuex";

export default {
  components: {
    Table,
    GenericButton,
    SellerUpdate,
    CheckIcon,
  },
  props: ["sellers"],
  emits: ["getSellers"],
  data() {
    return {
      selectedSeller: null,
    };
  },
  computed: {
    ...mapGetters("auth", ["hasAccessToAdminDashboard"]),
    columns() {
      return [
        { label: this.$t("Store"), field: "salesChannel" },
        { label: this.$t("First name"), field: "firstName" },
        { label: this.$t("Last name"), field: "lastName" },
        { label: this.$t("Email"), field: "email" },
        { label: this.$t("Phone"), field: "phone" },
        { label: this.$t("Complete"), field: "complete", slot: "complete" },
      ];
    },
  },
  methods: {
    isPresent,
    ...mapActions("sellers", ["delete"]),
    ...mapActions("notifications", ["notify"]),
    sellerIncomplete(seller) {
      return (
        !isPresent(seller.firstName) ||
        !isPresent(seller.lastName) ||
        !isPresent(seller.email) ||
        !isPresent(seller.phone)
      );
    },
    async deleteSeller(seller) {
      if (!confirm("Supprimer ce vendeur ?")) return;

      const response = await this.delete(seller.id);
      if (!response.success) return;

      await this.notify({
        category: "simple",
        type: "success",
        title: "Vendeur supprimé",
      });
      this.$emit("getSellers");
    },
  },
};
</script>
